import classnames from 'classnames';
import React from 'react';
import styles from './signUpNomadFeatures.module.scss';

export interface ISignUpNomadFeatures {
  id: number;
  icon: string;
  iconAlt: string;
  title: string;
  description: string;
}

interface SignUpNomadFeatureProps {
  signUpNomadFeatures: ISignUpNomadFeatures;
}

const SignUpNomadFeatures = ({
  signUpNomadFeatures,
}: SignUpNomadFeatureProps) => {
  const { icon, iconAlt, title, description } = signUpNomadFeatures;

  return (
    <div className={classnames(styles.featureContainer)}>
      <div className={classnames(styles.featureImage)}>
        <img
          src={icon}
          alt={iconAlt}
          className={classnames('d-block mx-auto')}
        />
      </div>
      <div className={classnames(styles.featureText)}>
        <p
          className={classnames('w-100 text-light1 text-left', styles.textBold)}
        >
          {title}
        </p>
        <p className={classnames('w-100 text-light1 text-left', styles.text)}>
          {description}
        </p>
      </div>
    </div>
  );
};

export default SignUpNomadFeatures;
